import { useEffect, useState } from 'react'
import { usePWAMode } from './appRootHooks'
import getIsTWAMode from '../helpers/appMode_helper'

const useExternalLinks = (twaScheme = 'togetherscheme') => {
  const isTWA = getIsTWAMode()
  const isPWA = usePWAMode()
  const [src, setSrc] = useState('')
  useEffect(() => {
    const handleExternalLinks = (event) => {
      let target = event.target

      // Traverse up the DOM to find the closest ancestor <a> tag with target="_blank"
      while (target && target.tagName !== 'A') {
        target = target.parentElement
      }

      if (target?.tagName === 'A' && target?.target === '_blank') {
        event.preventDefault()
        if (isTWA) {
          const encodedHref = encodeURIComponent(target.href)
          window.location.href = `${twaScheme}://open?url=${encodedHref}`
        } else {
          // Must be in non-TWA PWA mode, so let the browser handle the link natively
          window.open(target.href, '_blank')
        }
      }
    }

    if (isPWA) {
      document.addEventListener('click', handleExternalLinks, true)
    }

    return () => {
      document.removeEventListener('click', handleExternalLinks, true)
    }
  }, [isPWA, isTWA, twaScheme])

  return [src, setSrc]
}

export default useExternalLinks
